import type { FunctionComponent } from 'react';
import { withConsumerGate } from './components/consumer-route-gate';
import { ConsumerFlowEntry } from './consumer-flow-entry';
import { ConsumerFlowPage } from './consumer-flow-page';
import { CONSUMER_PATHS } from './lib/paths';
import { PolicyReviewDocumentPage } from './pages/policy-review-document-page';

export const CONSUMER_ROUTE_DEFS: { path: string; page: FunctionComponent<any> }[] = [
  { path: CONSUMER_PATHS.entry, page: withConsumerGate(ConsumerFlowEntry) },
  { path: CONSUMER_PATHS.step, page: withConsumerGate(ConsumerFlowPage) },
  // For the Waterlily team, who aren't in the consumer flow; the server checks who may download.
  { path: CONSUMER_PATHS.policyReviewDocument, page: PolicyReviewDocumentPage },
];
